import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'sn-searchbar',
	template: require('./searchbar.html'),
	styles: [require('./searchbar.scss')]
})
export class SearchbarComponent implements OnInit {
	@Input() placeholder: string;
	@Input() debounce: number;
	@Output() searchChange: EventEmitter<any> = new EventEmitter();
	queryField: FormControl = new FormControl();

	ngOnInit() {
		this.queryField.valueChanges
			.debounceTime(this.debounce || 500)
			.distinctUntilChanged()
			.map(search => search.trim())
			.subscribe(search => {
				this.searchChange.emit(search);
			});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/common/searchbar/searchbar.ts